import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './FooterBlock.css';
import { withQuery } from '../../../hoc/withGraphql';

// Component
import FooterBlockForm from '../../../components/siteadmin/FooterBlockForm';
import Loader from '../../../components/Loader';

class FooterBlock extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getFooterSettting: PropTypes.object,
    })
  };

  static defaultProps = {
    data: {
      loading: true,
      image: null
    }
  };


  render() {
    const { data: { loading, getFooterSetting }, title } = this.props;
    if (loading) {
      return <Loader type={"text"} />;
    } else {
      return <FooterBlockForm initialValues={getFooterSetting} />
    }
  }

}

export default compose(
  withStyles(s),
  withQuery(gql`
        {
            getFooterSetting {
                id
                title1
                content1
                title2
                content2
                title3
                content3
            }
        }
      `, {
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  }),
)(FooterBlock);
